import React from 'react';

const NotFound = () => {
  return (
    <div>404: Not Found</div>
  );
};

export default NotFound;


// WEBPACK FOOTER //
// ./containers/sider/notfound.js